import { Button, Link } from "@walmart-web/livingdesign-components"
import React from "react"
import { CalendarFooterProps } from "./MultiRangeCalendar.domain"
import { useIntl } from "react-intl"

const CalendarFooter: React.FC<CalendarFooterProps> = (props) => {
	const { onSubmit, onCancelSubmit } = props
	const intl = useIntl()

	return (
		<div className="multi-calendar-range__submit">
			<Link
				data-testid="range-calendar-cancel-button"
				style={{ cursor: "pointer" }}
				onClick={onCancelSubmit}
				UNSAFE_className="multi-calendar-range__cancel__button"
			>
				{intl.formatMessage({ id: "phronesis.buttons.cancel" })}
			</Link>
			<Button
				data-testid="range-calendar-submit-button"
				variant="primary"
				onClick={onSubmit}
				UNSAFE_className="multi-calendar-range__submit__button"
			>
				{intl.formatMessage({ id: "phronesis.buttons.update" })}
			</Button>
		</div>
	)
}

export default CalendarFooter
